import i18n from '@src/i18n'

function pricesHaveMergedFixedPriceLine(prices) {
  return (prices || []).some(
    (price) => price.has_fixed_price && price.merge_fix_price_line
  )
}

function pluralizeUnitLabel(label, quantity) {
  const forms = label?.split('|').map((form) => form.trim())
  if (!forms?.length) return undefined

  const qty = Math.abs(quantity)
  const index =
    forms.length === 2
      ? qty
        ? qty > 1
          ? 1
          : 0
        : 1
      : qty
        ? Math.min(qty, 2)
        : 0

  return forms[Math.min(index, forms.length - 1)]
}

export default {
  /**
   * @param quantity Quantité de la ligne, ramenée à 1 si non renseignée
   * @param unit Unité de quantité de l'article, multi-locale avec formes plurielles séparées par '|'
   * (1 forme : invariable, 2 formes : singulier|pluriel, 3 formes : zéro|singulier|pluriel)
   */
  formatQuantityWithUnit(quantity, unit) {
    const qty = quantity ?? 1
    const label = pluralizeUnitLabel(
      unit?.[i18n.vueI18n.global.locale],
      qty
    )
    return `${qty}${label ? ' ' + label : ''}`
  },
  /**
   * @param item L'article global (item/getSelectedItem), avec ses propres prix
   */
  hasMergedFixedPriceLine(item) {
    if (!item) return false

    return item.advanced_pricing
      ? pricesHaveMergedFixedPriceLine(item.prices)
      : item.has_fixe_price && item.default_merge_fix_price_line
  },
  /**
   * @param specific Le spécifique (itemSpecific) en cours d'édition, avec ses propres prix
   */
  specificHasMergedFixedPriceLine(specific) {
    if (!specific || specific.prices_inherit_from_item) return false

    return specific.specific_advanced_pricing
      ? pricesHaveMergedFixedPriceLine(specific.prices)
      : specific.specific_has_fixe_price &&
          specific.specific_merge_fix_price_line
  },
  /**
   * @param field Nom du champ à vérifier selon l'endpoint d'origine (ex: 'invoice_items_in_invoice' vs 'invoice_items')
   */
  isItemAlreadyInvoiced(item, field = 'invoice_items_in_invoice') {
    return (item?.[field]?.length ?? 0) > 0
  },
  groupComponentsByParentId(items, field = 'invoice_items_in_invoice') {
    const flatItems = items ?? []
    const itemsById = {}
    flatItems.forEach((item) => {
      itemsById[item.id] = item
    })
    const map = {}
    flatItems
      .filter((item) => {
        if (!item.component_parent_id) return false
        if (this.isItemAlreadyInvoiced(item, field)) return false
        return !this.isItemAlreadyInvoiced(
          itemsById[item.component_parent_id],
          field
        )
      })
      .forEach((item) => {
        if (!map[item.component_parent_id]) {
          map[item.component_parent_id] = []
        }
        map[item.component_parent_id].push(item)
      })
    return map
  }
}
